import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import ShippingCompanyCard from "./ShippingCompanyCard";
import { getShipnameList, getCompanynameList } from "../Actions/HelpersAPI";
import { getMmplCompaniesList } from "../Actions/MMPLDashboardAPI";
import { getShippingCompanyList } from "../Actions/ShipViewAPI";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import Autocomplete from "react-autocomplete";
import clear from "../Asset/clear.svg";
import "../Asset/css/dashboard.css";

let userRole = localStorage.getItem("UserRoles");

class ShippingCompanyDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchClients: {
        clientName: "",
        clientId: 0,
        PageNumber: 1,
        PageSize: 25,
      },
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    this.props.dispatch({ type: "SubBannerTitle", data: "Client Dashboard" });
    const { params } = match;
    dispatch(getShipnameList());
    dispatch(getCompanynameList());
    dispatch(getMmplCompaniesList(this.state.searchClients));
  }
  MMPLDashboardShipNavigation = (e, clientId) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Details" });
    this.props.history.push(`/Home/Client/ShipDetails/${clientId}`);
    e.preventDefault();
  };
  MMPLDashboardCrewNavigation = (e, clientId) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Crew Details" });
    this.props.history.push(`/Home/Client/CrewDetails/${clientId}`);
    e.preventDefault();
  };
  MMPLCalibartionDueNavigation = (e, clientId) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Device Calibration Due",
    });
    this.props.history.push(`/Home/client/DeviceCalibration/${clientId}`);
    e.preventDefault();
  };
  handleAnnualSearchChange = (e, node) => {
    const { dispatch } = this.props;
  
    if (node === "clientName") {
      this.state.searchClients.clientName = e.target.value;
    }
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    const { dispatch } = this.props;
    this.state.searchClients[field] = value;
    this.state.searchClients[fieldId] = id;
    this.setState({});
  };
  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }
  renderCompanyNameTitle(state, val) {
    return (state?.clientName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }
  ClearClientsField(){
    const{dispatch}=this.props;
    this.state.searchClients.clientName = "";
    this.state.searchClients.clientId=0;
    this.setState({});
    dispatch(getMmplCompaniesList(this.state.searchClients))
  }
  SearchClients(value){
    const{dispatch}=this.props;
    this.state.searchClients.PageNumber=value;
    dispatch(getMmplCompaniesList(this.state.searchClients))

  }
  renderPopoverThirtyDays(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>Callibration due is expire in thirty days for one of the ship.</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderPopoverSixtyDays(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>Callibration due is expire in sixty days for one of the ship.</label>
        </Popovers.Content>
      </Popovers>
    );
  }

  renderPopover(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            Callibration due is expire for one of the ship.
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  render() {
    const { MMPLCompaniesList,CompanyList } = this.props;
    return (
      <div
        className="full-height pt-3 pb-1 my-4"
        style={{ backgroundColor: "#F1F5F9", borderRadius: 14, height: "70vh" }}
      >
        <div className="row mx-0 pt-2 px-4">
        <div className="col-12">
            <div className="pt-4 px-2 mx-1 row">
              <div className="col-xl-4">
                <label className="label-card pbm10px">Clients</label>
              </div>
              <div className="col-xl-8 my-auto">
                <div className="row pl-2 prd-4 mbm1rem">
                <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                   </div>
                  <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3">
                    <Autocomplete
                      value={this.state.searchClients.clientName}
                      contentEditable={true}
                      inputProps={{
                        placeholder: "Client Name",
                      }}
                      items={CompanyList ?? []}
                      name="clientName"
                      getItemValue={(item) => item.clientName}
                      shouldItemRender={this.renderCompanyNameTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item.clientName}
                        </div>
                      )}
                      onChange={(e) =>
                        this.handleAnnualSearchChange(e, "clientName")
                      }
                      onSelect={(value, item) =>
                        this.handleAnnualSelectChange(
                          value,
                          "clientName",
                          item.clientID,
                          "clientId"
                        )
                      }
                    />
                  </div>
                 

                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                      type="submit"
                      onClick={() => this.SearchClients(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                    <button
                      className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                      onClick={() => this.ClearClientsField()}
                      type="button"
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {MMPLCompaniesList && MMPLCompaniesList?.data?.length > 0 ? (
            <div className="col-12">
              <div className=" mt-0 mb-4 ml-4 mr-4 cardBck row">
                <div className="col-xl-12 py-3">
                  <div className="row px-3">
                    {MMPLCompaniesList?.data?.map((item, index) => {
                      return (
                        <>
                          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-2 cursor-pointer">
                            <div className="card ccard px-4 pt-3 h-100">
                              <div
                                className="bord-title pt-1"
                                onClick={(e) =>
                                  this.MMPLDashboardShipNavigation(
                                    e,
                                    item.shippingCompanyId
                                  )
                                }
                              >
                                {item.companyName}
                              </div>

                              <div
                                className="my-3"
                                style={{ border: "0.1px solid #EEEEEE" }}
                              ></div>
                              <div className="row">
                                <div
                                  className="sub-card pb-2 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4"
                                  onClick={(e) =>this.MMPLDashboardShipNavigation(e,item.shippingCompanyId)}>
                                  Ships
                                </div>
                                { item.isAnyExpired && item.isThirtyDaysDue && item.isSixtyDaysDue?
                                 <OverlayTrigger
                                 placement="bottom"
                                 delay={{ show: 250, hide: 400 }}
                                 overlay={this.renderPopover()}>
                               <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                               <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "#d41616f5", fontSize: "0.8rem" }}></i></div>
                               </OverlayTrigger>
                                :
                                item.isAnyExpired && item.isThirtyDaysDue?
                                <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderPopover()}>
                              <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                              <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "#d41616f5", fontSize: "0.8rem" }}></i></div>
                              </OverlayTrigger>
                                :item.isAnyExpired  && item.isSixtyDaysDue
                                ?
                                <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderPopover()}>
                              <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                              <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "#d41616f5", fontSize: "0.8rem" }}></i></div>
                              </OverlayTrigger>
                                :item.isAnyExpired?
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={this.renderPopover()}>
                                <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                                <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "#d41616f5", fontSize: "0.8rem" }}></i></div>
                                </OverlayTrigger>
                                :  item.isThirtyDaysDue&&item.isSixtyDaysDue?
                                <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderPopoverThirtyDays()}>
                               <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                              <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "rgb(255, 130, 90)", fontSize: "0.8rem" }}></i></div>
                              </OverlayTrigger>
                               : item.isThirtyDaysDue?
                                <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderPopoverThirtyDays()}>
                               <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                              <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "rgb(255, 130, 90)", fontSize: "0.8rem" }}></i></div>
                              </OverlayTrigger>:
                                     item.isSixtyDaysDue?
                                   <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={this.renderPopoverSixtyDays()}>
                                    <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0" onClick={(e)=>this.MMPLCalibartionDueNavigation(e,item.shippingCompanyId)}>
                                      <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ color: "rgb(255, 165, 0)", fontSize: "0.8rem" }}></i></div>
                               </OverlayTrigger>
                                      :
                                <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pl-0"></div>} 
                                <div className="sub-card pb-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"></div>
                                <div className="subcard-count pb-2 col-xl-4  col-lg-4 col-md-4 col-sm-4 col-4" onClick={(e) =>this.MMPLDashboardShipNavigation(e,item.shippingCompanyId)}>
                                  {item.totalShips}
                                </div>
                              </div>
                              <div
                                className="row">
                                <div className="sub-card py-2 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8"  onClick={(e) =>this.MMPLDashboardCrewNavigation(e, item.shippingCompanyId)}>
                                  Crew Members
                                </div>
                                <div className="subcard-count py-2 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4"  onClick={(e) =>this.MMPLDashboardCrewNavigation(e, item.shippingCompanyId)}>
                                  {item?.totalCrewMembers}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ) : MMPLCompaniesList?.data?.length === 0 ? (
            <div className="col-12">
              <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                <div class="container">
                  <h6 className="resource-list-title no-item-card">
                    <h6 className="bold-count no-item-card f-size">
                      No Clients to display
                    </h6>
                  </h6>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    CompanyList: state.UserManageReducer.CompanyList || [],
    MMPLCompaniesList: state.MMPLDashboardReducer.MMPLCompaniesList,
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShippingCompanyDashboard);
